import { useTranslation } from 'react-i18next';
import { SylndrHelpPoint, SylndrHelpPoints } from './sylndr-help.types';
import Image from 'next/image';
import { AVAILABLE_LANGUAGES } from '@/constants';
import { ChevronLeft } from 'public/Images';
import Typography from '@/components/shared/typography/typography.component';

export const SylndrHelpSectionMobile = ({
    lang,
    handleClickOnSection,
    clickable,
}: {
    lang: AVAILABLE_LANGUAGES;
    handleClickOnSection: (section: SylndrHelpPoint) => void;
    clickable: boolean;
}) => {
    const { t } = useTranslation();
    // const [vidURL, setVidURL] = useState('');
    return (
        <div className="px-4 py-5 bg-sky-50 -mx-4 md:pt-4 md:pb-5">
            <div className="md:flex md:justify-between">
                <div className="mb-3">
                    <div className="flex flex-col gap-0.5">
                        <Typography className="text-gray-800 text-body1SemiBold">
                            {t('CarProfile.SylndrHelp.title')}
                        </Typography>
                        <Typography className="text-caption text-gray-600">
                            {t('CarProfile.SylndrHelp.subTitle')}
                        </Typography>
                    </div>
                    {/* <div
                    className="hidden md:flex md:gap-x-1 md:items-center cursor-pointer"
                    onClick={() => {
                        setVidURL(CarTypeVideosURL.CERTIFIED_DEALER_DESKTOP);
                    }}
                >
                    <Image src={PlayCircle} alt="play" />
                    <div className='"justify-start text-blue-800 text-sm font-bold mt-0.5'>
                        {t('CarProfile.SylndrHelp.VideoEntryPoint.title')}
                    </div>
                    <VideoOverlay vidURL={vidURL} setVidURL={setVidURL} />
                </div> */}
                </div>
            </div>
            <div className="flex flex-col gap-y-2 md:flex-row md:gap-x-4">
                {SylndrHelpPoints.map(section => {
                    return (
                        <SylndrHelpContainer
                            key={section.index}
                            section={section}
                            lang={lang}
                            handleClickOnSection={handleClickOnSection}
                            clickable={clickable}
                        />
                    );
                })}
            </div>
        </div>
    );
};

const SylndrHelpContainer = ({
    section,
    lang,
    handleClickOnSection,
    clickable,
}: {
    section: SylndrHelpPoint;
    lang: AVAILABLE_LANGUAGES;
    handleClickOnSection: (section: SylndrHelpPoint) => void;
    clickable: boolean;
}) => {
    return (
        <div
            className={`flex rounded-lg justify-between bg-white p-3 md:p-4 gap-x-3 ${
                clickable ? 'cursor-pointer' : ''
            }`}
            onClick={
                clickable ? () => handleClickOnSection(section) : undefined
            }
        >
            <div className="flex items-center gap-3">
                <div className="flex-shrink-0">
                    <Image
                        src={section.miniIcon}
                        alt={section.title.en}
                        className="en:transform en:scale-x-[-1]"
                    />
                </div>
                <div>
                    <div className="self-stretch justify-start text-slate-800 text-xs font-bold mb-0.5">
                        {section.title[lang]}
                    </div>
                    <div className="self-stretch justify-start text-gray-500 text-xs font-normal">
                        {section.subTitle[lang]}
                    </div>
                </div>
            </div>
            {clickable && (
                <Image
                    src={ChevronLeft}
                    alt="info"
                    className="flex-shrink-0 en:rotate-180 self-center"
                    width={18}
                    height={18}
                />
            )}
        </div>
    );
};
